import { MapExpression } from './expressions';

export enum GlobalFilters {
  FLOOR = 'floor-filter',
  LAYERS = 'layers-filter',
}

export interface LocalFilterOptions {
  globalExclusions?: GlobalFilters[];
  filter?: MapExpression;
}
